"use strict";

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.inject = void 0;

var _styledComponents = require("styled-components");

var _theme = require("../../../theme");

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n        cursor: not-allowed;\n        border-color: var(--c-light);\n      "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n        color: var(--c-neutral);\n      "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n        color: inherit;\n      "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n          &:hover {\n            border-color: var(--c-light);\n            box-shadow: var(--s-light);\n          }\n\n          &:focus-within {\n            ", "::placeholder {\n              opacity: 0;\n            }\n\n            border-color: var(--c-light);\n            box-shadow: var(--s-light);\n\n            &:after {\n              transform: scale(1);\n            }\n          }\n        "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n          &:active {\n            box-shadow: var(--s-light);\n\n            &:after {\n              transform: scale(1);\n            }\n          }\n        "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n        ", "\n\n        ", "\n      "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n        cursor: not-allowed;\n        color: var(--c-neutral);\n        background-color: var(--c-light);\n        border-color: var(--c-light);\n      "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var inputContainerDisabledStyles = function inputContainerDisabledStyles(_ref) {
  var isDisabled = _ref.isDisabled,
      Input = _ref.Input;
  return isDisabled ? (0, _styledComponents.css)(_templateObject()) : (0, _styledComponents.css)(_templateObject2(), _theme.Mixin.Device.mobile((0, _styledComponents.css)(_templateObject3())), _theme.Mixin.Device.desktop((0, _styledComponents.css)(_templateObject4(), Input)));
}; // File Input


var fileInputColorToggle = function fileInputColorToggle(value) {
  return typeof value !== 'undefined' && (value === null || value === void 0 ? void 0 : value.length) ? (0, _styledComponents.css)(_templateObject5()) : (0, _styledComponents.css)(_templateObject6());
};

var fileInputWrapperDisabledStyles = function fileInputWrapperDisabledStyles(isDisabled) {
  return isDisabled ? (0, _styledComponents.css)(_templateObject7()) : "";
};

var inject = {
  inputContainerDisabledStyles: inputContainerDisabledStyles,
  fileInputColorToggle: fileInputColorToggle,
  fileInputWrapperDisabledStyles: fileInputWrapperDisabledStyles
};
exports.inject = inject;